/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
import dayjs from 'dayjs';
import React, { useMemo, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { CommentsComponent } from '..';
import utc from 'dayjs/plugin/utc';
import _get from 'lodash/get';
import { IPostCategory, IPostModel } from '../../models';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import PostActionsComponent from './post-actions/post-actions.component';
import PostTypeImage from './post-types/post-type-image';
import PostTypeVideo from './post-types/post-type-video';
import PostTypeShare from './post-types/post-type-share';
import PostHastags from './post-hastags.component';
import PostMenu from './post-menu.component';
import PostHeader from './post-header.component';

dayjs.extend(utc);

export interface IPostProps {
  post?: IPostModel;
  isPostUser?: boolean;
  removePost?: any;
  isAdmin?: boolean;
  getPostCategory?: (id: string) => IPostCategory | undefined;
  isUnCheck?: boolean;
  customClassName?: string;
  highlightWords?: string[]; // New prop for banned words to highlight
}

export const Post: React.FC<IPostProps> = (props) => {
  const {
    post,
    isPostUser,
    removePost,
    isAdmin,
    getPostCategory,
    isUnCheck = false,
    customClassName,
    highlightWords = [], // Default to empty array if not provided
  } = props;

  const profileUser = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const currentCategory = getPostCategory?.(post?.categoryId ?? '');
  const isPostShare = post?.postType === 'share';
  const isPostImage = post?.postType === 'image';
  const isPostVideo = post?.postType === 'video';

  const userId = useMemo(() => {
    return profileUser?.userId;
  }, [profileUser]);

  // Hidden post state
  const [isHiddenPost, setIsHiddenPost] = useState('-1');
  // Nội dung nhạy cảm (18+): làm mờ, bấm mới xem
  const isSensitive = !!post?.isSensitive;
  const [revealed, setRevealed] = useState(false);
  const covered = isSensitive && !revealed;

  const rootRef = useRef<HTMLDivElement>(null);
  // Bấm nút bình luận → cuộn tới + focus ô "Thêm bình luận" của chính bài này.
  const handleCommentClick = () => {
    const input = rootRef.current?.querySelector(
      'input[placeholder="Thêm bình luận"]'
    ) as HTMLInputElement | null;
    if (!input) return;
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => input.focus(), 250);
  };

  if (isHiddenPost === post?.id) {
    return null;
  }

  return (
    <div
      ref={rootRef}
      className={`bg-white rounded-xl shadow-sm text-sm font-medium border border-[#DEE0E6] dark:border-slate-700 dark:bg-dark2 dark:border-slate-700 ${customClassName}`}
    >
      <div className="flex gap-[10px] items-center sm:p-4 p-4 text-sm border-b border-b-[#E5E7EB] dark:border-b-slate-700 font-medium">
        <PostHeader
          profileUser={!!profileUser}
          post={post}
          currentCategory={currentCategory ?? ({} as IPostCategory)}
        />

        {!isPostUser && !isAdmin ? (
          <PostMenu
            post={post as IPostModel}
            userId={userId || ''}
            removePost={removePost}
            setIsHiddenPost={setIsHiddenPost}
          />
        ) : null}
      </div>

      <div className="relative">
        <div className={covered ? 'pointer-events-none select-none blur-xl' : ''}>
          <div className="px-3 sm:px-4 pt-3">
            <Highlighter
              highlightClassName="bg-yellow-300"
              searchWords={highlightWords}
              textToHighlight={post?.content || ''}
              className="text-[15px] text-zinc-800 dark:text-zinc-50"
            />
            <PostHastags post={post} />
            {isPostShare && (
              <PostTypeShare
                post={post?.sharedPost}
                currentCategory={currentCategory}
              />
            )}
          </div>
          {(isPostImage || post?.postType === 'normal') && (
            <PostTypeImage post={post} />
          )}
          {isPostVideo && <PostTypeVideo post={post} />}
        </div>
        {covered && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-white/70 px-4 text-center backdrop-blur-sm dark:bg-slate-900/70">
            <span className="text-[15px] font-bold text-[#18191E] dark:text-white">
              Nội dung nhạy cảm (18+)
            </span>
            <span className="text-xs text-slate-500 dark:text-slate-400">
              Nội dung có thể không phù hợp với tất cả mọi người.
            </span>
            <button
              type="button"
              onClick={() => setRevealed(true)}
              className="mt-1 rounded-full bg-[#0057FF] px-4 py-1.5 text-sm font-semibold text-white hover:bg-blue-700"
            >
              Xem nội dung
            </button>
          </div>
        )}
      </div>
      {!isAdmin && !isUnCheck && (
        <PostActionsComponent
          post={post as IPostModel}
          isPostUser={isPostUser || false}
          profileUser={!!profileUser}
          onCommentClick={handleCommentClick}
        />
      )}
      {!isAdmin && !isUnCheck && (
        <CommentsComponent
          profileUser={!!profileUser}
          post={post}
          userId={userId || ''}
        />
      )}
      <div />
    </div>
  );
};

export default Post;
